import rhinoCore from 'rhino/src/core/core.module';
import rhinoLocale from 'rhino/src/components/locale/locale.module';
import gazelleAnalytics from 'gazelle/src/core/analytics/analytics.module';

import runCookieConsentScript from './consent.run';

export default angular.module('start.core.consent', [
  rhinoCore,
  rhinoLocale,
  gazelleAnalytics,
])
  .run(runCookieConsentScript)
  .name;



// WEBPACK FOOTER //
// ./components/consent/consent.module.js